import api from "@/libs/api";
import store from "@/store";

const initState = {
  tableList: [],//表目录
  fileList: [],//文件目录 
  savedList: {},//保存的查询
  savedDtaaList: {},//保存的查询  all
};

const customizedQueries = {
  state: initState,
  mutations: {
    SET_TABLE_LIST(state, list) {
      state.tableList = list;
    },
    SET_FILE_LIST(state, list) {
      state.fileList = list;
    },
    SET_SAVE_LIST(state, list) {
      state.savedList = list;
    },
    SET_SAVEDATA_LIST(state, list) {
      state.savedDtaaList = list;
    },
  },
  getters: {},
  actions: {
    // 获取表目录
    getTable({ commit }, projectId) {
      api
        .getTableList(projectId)
        .then((res) => {
          commit("SET_TABLE_LIST", res.data.fields.list);
        })
    },
    // 获取文件目录
    getFile({ commit }, projectId) {
      api
        .getFileList(projectId)
        .then((res) => {
          res.data.fields.list.forEach(el => {
            el.show = false
          });
          commit("SET_FILE_LIST", res.data.fields.list);
        })
    },
    // 获取保存的查询语句   单
    getSaveStatement({ commit }, projectId, id) {
      api
        .getSaveStatement(projectId, id)
        .then((res) => {
          commit("SET_SAVE_LIST", res.data.fields);
        })
    },
    // 获取保存的查询语句  全
    getSaveStatementAll({ commit }, projectId) {
      api
        .getSaveStatementAll(projectId)
        .then((res) => {
          commit("SET_SAVEDATA_LIST", res.data.fields.list);
        })
    },
  }
};

export default customizedQueries;



// WEBPACK FOOTER //
// ./src/store/modules/customized_queries.js